import actionTypes from '../actions/reduxActions/actionTypes';

const initialState = {
    selectedElementIds: [],
    hoveringMapElementId: null,
    hoveringGroupElementId: null,
    draggingOverGroupElementId: null,
    previousDraggingPosition: { x: 0, y: 0 },
    dragging: null,
    // dragging has shape: {
    //     dragType,
    //     elementId,
    //     previousElementPosition,
    //     previousMousePosition,
    //     initialMousePosition,
    //     hasMovedEnough,
    // },
    contextMenu: null,
    // contextMenu has shape: {
    //     show,
    //     x,
    //     y,
    //     activeElement: {
    //         id,
    //         type,
    //     }
    // },
};

const graph = (graphState = initialState, { type, payload, error, meta }) => {
    switch (type) {
    case actionTypes.GRAPH_SET_SELECTED_ELEMENT_IDS: {
        let selectedElementIds;

        if (graphState.selectedElementIds.includes(payload)) {
            selectedElementIds = graphState.selectedElementIds.filter(id => id !== payload);
        } else {
            selectedElementIds = [...graphState.selectedElementIds, payload];
        }

        return { ...graphState, selectedElementIds };
    }
    case actionTypes.GRAPH_SET_SELECTED_ELEMENT_ID: {
        return { ...graphState, selectedElementIds: [payload] };
    }
    case actionTypes.GRAPH_RESET_SELECTIONS:
        return { ...graphState, selectedElementIds: [] };
    case actionTypes.GRAPH_SET_HOVER_MAP_ID:
        return { ...graphState, hoveringMapElementId: payload };
    case actionTypes.GRAPH_SET_HOVER_GROUP_ID:
        return { ...graphState, hoveringGroupElementId: payload };
    case actionTypes.GRAPH_SET_DRAG_OVER_GROUP_ID:
        return { ...graphState, draggingOverGroupElementId: payload };
    case actionTypes.GRAPH_SET_DRAGGING_DATA:

        // If we are setting the dragging props for the first time from null
        // to something that isn't null
        // then also save the mouse position as the initial mouse position
        if (graphState.dragging === null && payload) {
            payload.initialMousePosition = payload.previousMousePosition;
        }
        
        return { ...graphState, dragging: payload };
    case actionTypes.GRAPH_SET_CONTEXT_MENU_DATA:
        return { ...graphState, contextMenu: payload };
    default:
        return graphState;
    }
};

export default graph;
